export default __webpack_public_path__ + "static/media/cart-block.60278117.svg";